export default {
  "content": "<path d=\"M6.247 4h-2v2h2V4zM4.247 8h2v2h-2V8zM10.247 4h-2v2h2V4zM8.247 8h2v2h-2V8z\" fill=\"#000\" fill-opacity=\".9\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.247 3a3 3 0 013-3h8a3 3 0 013 3v5h3.003a3 3 0 013 3v9H.247V3zm6 15h2v-4h-2v4zm4 0v-6h-6v6h-2V3a1 1 0 011-1h8a1 1 0 011 1v15h-2zm7.003-8h-3v8h4v-7a1 1 0 00-1-1z\" fill=\"#000\" fill-opacity=\".9\"/>",
  "attrs": {
    "width": "21",
    "height": "20",
    "viewBox": "0 0 21 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};